import { combineReducers } from '@reduxjs/toolkit';
import baseAppReducer from './appSlice';
import domainCheckReducer from '../Features/DomainCheckInput/domainCheckSlice';
import { loadersReducer } from '../../common/thunk';

export const appReducer = combineReducers({
  base: baseAppReducer,
  loader: loadersReducer,
  domain: domainCheckReducer,
});

export default appReducer;
